
import { defineComponent } from 'vue';
import { mdiMagnify } from '@mdi/js';
import Icon from '../Icon.vue';
import { getModule } from 'vuex-module-decorators';
import SignageState, { ISignageState } from '../../store/modules/signage';

let signageState = {} as ISignageState;

export default defineComponent({
    name: "WeatherTodaylayoutEditor",
    data: ()=>({
        displayLightbox: false,
        popoutPreview: false,
        editLocation: false,
        newLocation: '',
        locations: [] as any[],
        signageItemLayoutData: {} as any,
        mdiMagnify
    }),

    components: {
        Icon
    },

    props: {
        layoutDataEdit: {
            type: Object,
            default: null
        },
    },

    methods: {
        async searchLocations(location: any, cb: any) {
            if(location !== '') {  
                const locationResponse = await signageState.getWeatherLocations(location);
                if(locationResponse.data) {  
                    cb(locationResponse.data);
                }
            }
             else {
                 this.locations = [];
             }
        },

        handleLocationSelect(location: any) {
            this.newLocation = location
            this.signageItemLayoutData.location = location;
            this.editLocation = false;
            this.newLocation = '';
        },

        onEditLocation() {
            if(this.editLocation) {
                this.editLocation = false;
                this.newLocation = '';
            }
            else {
                this.editLocation = true;
            }
        }
    },

    created (){
        signageState = getModule(SignageState);

        this.signageItemLayoutData = JSON.parse(JSON.stringify(this.layoutDataEdit));
    },

    watch: {
        'signageItemLayoutData': {
            handler(newValue: any){
                this.$emit('updateLayoutData', {updatedLayoutData: newValue, shouldUpdatePreview: false});
            },
            deep: true
        }
    }
});
